<template>
    <div
        class="w-full gap-4 p-1"
        :class="
            isFewItems
                ? 'flex flex-wrap justify-center'
                : ['grid', isDesktop ? 'grid-cols-6' : 'grid-cols-1']
        "
    >
        <component
            :is="item.href ? 'a' : 'div'"
            v-for="(item, index) in items"
            :key="item.key"
            v-bind="linkAttrs(item)"
            :aria-label="item.title"
            class="relative flex overflow-hidden bg-stack-text no-underline transition-all duration-300 ease-in-out"
            :class="[
                isDesktop ? 'h-56' : 'h-40',
                isFewItems
                    ? isDesktop
                        ? 'w-80'
                        : 'w-full'
                    : ['w-full', gridPositionClass(index)]
            ]"
            @click="onClick"
        >
            <img
                v-if="item.imageUrl"
                :src="item.imageUrl"
                :alt="item.imageAlt"
                class="absolute inset-0 h-full w-full transform object-cover transition-transform duration-300 hover:scale-110"
            />
            <div v-else class="absolute inset-0">
                <slot name="placeholder" :item="item"></slot>
            </div>
        </component>
    </div>
</template>

<script>
export default {
    name: "SliderV7",
    props: {
        items: { type: Array, required: true },
        previewOnly: { type: Boolean, default: false },
        isDesktop: { type: Boolean, default: true }
    },
    computed: {
        // Con menos de 3 ítems (la primera fila del patrón 3/2) las tarjetas
        // se centran en un flex (regla de "pocas imágenes").
        isFewItems() {
            return this.items.length < 3;
        }
    },
    methods: {
        gridPositionClass(index) {
            if (!this.isDesktop) return "";
            let accumulatedItems = 0;
            let row = 0;

            while (accumulatedItems <= index) {
                const itemsInRow = row % 2 === 0 ? 3 : 2;
                accumulatedItems += itemsInRow;
                if (accumulatedItems > index) break;
                row++;
            }

            return row % 2 === 0 ? "col-span-2" : "col-span-3";
        },
        linkAttrs(item) {
            return item.href
                ? { href: item.href, target: item.target, rel: item.rel }
                : {};
        },
        onClick(event) {
            if (this.previewOnly) event.preventDefault();
        }
    }
};
</script>
